import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const massMolarityTool: Tool = {
  id: "mass-molarity",
  name: () => m.massmol_tool_name(),
  description: () => m.massmol_tool_description(),
  icon: "⚗️",
  basePath: "/mass-molarity",
  status: "stable",
  tags: [
    "calculator",
    "chemistry",
    "science",
    "lab",
    "molarity",
    "concentration",
  ],
};
